import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ user, allowedRoles, children }) => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/dashboard/admin");

  // 1️⃣ Pas connecté
  if (!user?.token) {
    return (
      <Navigate
        to={isAdminRoute ? "/login_admin" : "/login"}
        replace
      />
    );
  }
  // 2️⃣ Connecté mais mauvais rôle
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    switch (user.role) {
      case "MEDECIN":
        return <Navigate to="/dashboard/medecin" replace />;

      case "GESTIONNAIRE":
        return <Navigate to="/dashboard/collectivite" replace />;

      case "SUPER_ADMIN":
        return <Navigate to="/dashboard/admin" replace />;

      case "USAGER":
        return <Navigate to="/dashboard/usager" replace />;

      default:
        return <Navigate to="/login" replace />;
    }
  }
  return children;
};

export default ProtectedRoute;
